<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { RADICAL, KANJI, VOCABULARY } from "./constants.js";
  import { reverseImmutable } from "./helpers.js";
  import { sortStore, currentViewStore, flashCardModeStore } from "./stores.js";
  import SubjectsGroup from "./SubjectsGroup.svelte";
  import SubjectCard from "./SubjectCard.svelte";
  export let subjects;
  export let currentLevels = [];

  $: parseSubjectsByLevel = () => {
    const byLevel = reverseImmutable(currentLevels).map(level => ({
      level,
      subjects: prepRecentlyViewedSubjects(subjects, level)
    }));
    return byLevel.map(levelGroup => {
      return {
        level: levelGroup.level,
        subjects: {
          vocabulary: sortSubjectGroup(levelGroup.subjects, VOCABULARY),
          kanji: sortSubjectGroup(levelGroup.subjects, KANJI),
          radicals: sortSubjectGroup(levelGroup.subjects, RADICAL)
        }
      };
    });
  };

  $: sortByMostMissed = () => {
    return subjects.sort((a, b) => a.percentage_correct - b.percentage_correct);
  };

  $: randomSort = () => {
    const toSort = [].concat(subjects);
    const randomizedSubjects = [];
    while (toSort.length) {
      const itemIndex = Math.floor(Math.random() * toSort.length);
      randomizedSubjects.push(toSort[itemIndex]);
      toSort.splice(itemIndex, 1);
    }
    return randomizedSubjects;
  };

  function pickRandomItem(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function prepRecentlyViewedSubjects(subjects, level) {
    return subjects
      .filter(subj => subj.level === level)
      .sort((a, b) => new Date(b.date_started) - new Date(a.date_started));
  }

  function sortSubjectGroup(group, type) {
    const filtered = group.filter(subj => subj.type === type);
    return filtered;
  }

  function getTypes(levelGroup) {
    return Object.keys(levelGroup.subjects);
  }

  const dispatch = createEventDispatcher();

  afterUpdate(() => {
    const options = {
      rootMargin: "0px 0px -30% 0px",
      threshold: 0
    };
    const groupings = document.querySelectorAll("[data-subject-grouping]");
    groupings.forEach(grouping => {
      const observer = new IntersectionObserver(entry => {
        if (entry[0].isIntersecting && grouping.dataset.subjectGrouping) {
          currentViewStore.set(grouping.dataset.subjectGrouping);
        }
      }, options);
      observer.observe(grouping);
    });
  });
</script>

<style>
  .nullstate {
    display: flex;
    font-size: 6rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .nullstate div {
    color: rgba(1, 62, 76, 0.2);
    font-weight: 700;
  }

  .shrug {
    font-size: 3rem;
  }

  @media screen and (max-width: 768px) {
    .nullstate {
      font-size: 4rem;
    }
  }
</style>

<section id="results" data-testId="results">
  {#if !subjects.length}
    <div class="nullstate">
      <div>No Results</div>
      <div class="shrug">¯\_(ツ)_/¯</div>
    </div>
  {:else}
    {#if $sortStore === 'recently started'}
      {#each parseSubjectsByLevel() as group}
        {#each getTypes(group) as type}
          {#if group.subjects[type].length}
            <SubjectsGroup
              level={group.level}
              title={type}
              subjects={group.subjects[type]} />
          {/if}
        {/each}
      {/each}
    {/if}

    {#if $sortStore === 'frequently missed'}
      <SubjectsGroup subjects={sortByMostMissed()} allLevels={currentLevels} />
    {/if}

    {#if $sortStore === 'random'}
      <SubjectsGroup subjects={randomSort()} />
    {/if}
  {/if}

</section>
